<school-two-column-layout>
    <settings-left-nav></settings-left-nav>
</school-two-column-layout>


